import { render, staticRenderFns } from "./FormHeader.vue?vue&type=template&id=8ff5fccc&"
import script from "./FormHeader.vue?vue&type=script&lang=js&"
export * from "./FormHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ff5fccc')) {
      api.createRecord('8ff5fccc', component.options)
    } else {
      api.reload('8ff5fccc', component.options)
    }
    module.hot.accept("./FormHeader.vue?vue&type=template&id=8ff5fccc&", function () {
      api.rerender('8ff5fccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-header/FormHeader.vue"
export default component.exports